import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-self-employment ("Einkünfte aus selbst. Tätigkeit", tab Bank): its fields of `bank` and the bank attachments of its types. Read through
 * `Project.blocks.bankSelfEmployment`, which checks the block's read permission.
 */
export const PROJECT_BANK_SELF_EMPLOYMENT_FIELDS = gql`
  fragment projectBankSelfEmploymentFields on ProjectBankSelfEmploymentBlock {
    id
    number
    bank {
      selfEmploymentNetIncome
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
  }
`;
